module.exports = __webpack_public_path__ + "sb.svg?5bc69a36b0852ca3e1023a0bfc21660e";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/sb.svg
// module id = 1342
// module chunks = 0